import React from 'react'
import { MatchUpStatusEnum } from 'types/global'
import StatusTag from './StatusTag'

const WinTag = {
  WALKOVER: () => <StatusTag status={MatchUpStatusEnum.WALKOVER} />,
  SUSPENDED: () => <StatusTag status={MatchUpStatusEnum.SUSPENDED} />,
}

const LossTag = {
  RETIRED: () => <StatusTag status={MatchUpStatusEnum.RETIRED} />,
  ABANDONED: () => <StatusTag status={MatchUpStatusEnum.ABANDONED} />,
  DEFAULTED: () => <StatusTag status={MatchUpStatusEnum.DEFAULTED} />,
  DISQUALIFIED: () => <StatusTag status={MatchUpStatusEnum.DISQUALIFIED} />,
  DEAD_RUBBER: () => <StatusTag status={MatchUpStatusEnum.DEAD_RUBBER} />,
  SUSPENDED: () => <StatusTag status={MatchUpStatusEnum.SUSPENDED} />,
}

interface Props {
  status: MatchUpStatusEnum
  isWinTag: boolean
}

const WinnerOrLoserTag = ({ status, isWinTag }: Props) => {
  const Tag = isWinTag ? WinTag[status] : LossTag[status]
  if (!Tag) return null
  return <Tag />
}

export default WinnerOrLoserTag
